// extracted by mini-css-extract-plugin
export default {"quote":"Quote_quote__CcHCY","subtitle":"Quote_subtitle__Sj+u+","author":"Quote_author__BbrlK"};